import React, { useState } from "react";
import styles from "./Styles/GiftCardSection.module.css";
import { getDownloadLink } from "../../utils/appLinks";

type TradeMode = "sell" | "buy";

interface GiftCardRate {
  name: string;
  color: string;
  sellRate: string;
  buyRate: string;
}

const GIFT_CARD_RATES: GiftCardRate[] = [
  { name: "Amazon", color: "#ff9900", sellRate: "Up to ₦1,050/$1", buyRate: "From ₦1,180/$1" },
  { name: "iTunes & Apple", color: "#a970ff", sellRate: "Up to ₦980/$1", buyRate: "From ₦1,120/$1" },
  { name: "Steam", color: "#66c0f4", sellRate: "Up to ₦960/$1", buyRate: "From ₦1,090/$1" },
  { name: "Google Play", color: "#34d399", sellRate: "Up to ₦940/$1", buyRate: "From ₦1,070/$1" },
];

const GiftCardSection: React.FC = () => {
  const [mode, setMode] = useState<TradeMode>("sell");

  return (
    <div className={styles.container}>
      <div className={styles.textContent}>
        <span className={styles.eyebrow}>Gift card exchange</span>
        <h2>
          Trade Gift Cards, <span className={styles.brand}>Instantly</span>
        </h2>
        <p className={styles.description}>
          Sell your unused gift cards for the best rates in minutes, or buy
          verified cards at prices that beat the market. Every trade is
          checked and paid out fast, with no hidden fees.
        </p>

        <div className={styles.toggle}>
          <button
            type="button"
            className={mode === "sell" ? styles.active : ""}
            onClick={() => setMode("sell")}
          >
            Sell
          </button>
          <button
            type="button"
            className={mode === "buy" ? styles.active : ""}
            onClick={() => setMode("buy")}
          >
            Buy
          </button>
        </div>

        <div className={styles.rateList}>
          {GIFT_CARD_RATES.map((card) => (
            <div className={styles.rateItem} key={card.name}>
              <span
                className={styles.swatch}
                style={{ background: card.color }}
              />
              <span className={styles.brandName}>{card.name}</span>
              <span className={styles.rateBadge}>
                {mode === "sell" ? card.sellRate : card.buyRate}
              </span>
            </div>
          ))}
        </div>

        <div className={styles.ctaRow}>
            <a href={getDownloadLink()} target="_blank" rel="noopener noreferrer">
          <button className={styles.ctaButton}>
              {mode === "sell" ? "Sell a gift card →" : "Buy a gift card →"}
          </button>
            </a>
          <span className={styles.ctaNote}>
            Payout in under 15 minutes, 24/7.
          </span>
        </div>
      </div>

      <div className={styles.stackWrapper}>
        <div className={styles.floatingPill}>
          <span className={styles.dot} />
          Rates updated live
        </div>

        <div className={`${styles.card} ${styles.card1}`}>
          <div className={styles.cardTop}>
            <span className={styles.cardChip} />
          </div>
          <span className={styles.cardBrand}>Steam</span>
          <span className={styles.cardValue}>$50.00</span>
        </div>

        <div className={`${styles.card} ${styles.card2}`}>
          <div className={styles.cardTop}>
            <span className={styles.cardChip} />
          </div>
          <span className={styles.cardBrand}>Amazon</span>
          <span className={styles.cardValue}>$100.00</span>
        </div>

        <div className={`${styles.card} ${styles.card3}`}>
          <div className={styles.cardTop}>
            <span className={styles.cardChip} />
          </div>
          <span className={styles.cardBrand}>iTunes</span>
          <span className={styles.cardValue}>$25.00</span>
        </div>
      </div>
    </div>
  );
};

export default GiftCardSection;
